import { Construction, VideoCameraFront } from '@mui/icons-material';
import { Collapse, IconButton, Tooltip, Stack, Divider } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useMutation } from "@apollo/client/react";
import { useSnackbar } from 'notistack';
import { PATH_MAIN } from '../../../routes/paths';
import Iconify from '../../../components/Iconify';
import useAuth from '../../../hooks/useAuth';
import { CREATE_DEMO_APPOINTMENTS } from '../../../graphql/resolvers/mutations';
import { SEARCH_APPOINTMENTS } from '../../../graphql/resolvers/queries';

function ToolsAccordion() {
    const [isOpen, setIsOpen] = useState(false);
    const { isProvider } = useAuth();
    const { enqueueSnackbar } = useSnackbar();

    const navigate = useNavigate();
    const location = useLocation();

    const [createDemoAppointments, { loading: createDemoAppointmentsLoading }] = useMutation(
        CREATE_DEMO_APPOINTMENTS,
        {
            onCompleted: () => {
                enqueueSnackbar('Test appointments created successfully', { variant: 'success' });
                if (location.pathname !== PATH_MAIN.general.dashboard) {
                    navigate(PATH_MAIN.general.dashboard);
                } else {
                    navigate(0);
                }
            },
            onError: (error) => {
                enqueueSnackbar(error.message, { variant: 'error' });
            },
            refetchQueries: [SEARCH_APPOINTMENTS],
        }
    );

    const handleClick = () => {
        setIsOpen((prev) => !prev);
    };

    const handleTestSessionClick = () => {
        navigate(`${PATH_MAIN.general.liveSession}?test-session=true`);
    };

    const handleTestAppointmentsClick = () => {
        void createDemoAppointments();
    };

    return (
        <Stack direction="row">
            <Tooltip title="Tools">
                <IconButton onClick={handleClick} sx={{ m: 0 }}>
                    <Construction />
                </IconButton>
            </Tooltip>
            <Collapse orientation="horizontal" in={isOpen}>
                <Stack direction="row" alignItems="center" gap={1.5} sx={{ pl: 1 }}>
                    <Divider orientation="vertical" flexItem sx={{ borderStyle: 'dashed' }} />
                    <Tooltip title="Start a test session">
                        <IconButton onClick={handleTestSessionClick}>
                            <VideoCameraFront />
                        </IconButton>
                    </Tooltip>
                    {isProvider && (
                        <Tooltip title="Create test appointments">
                            <IconButton
                                onClick={handleTestAppointmentsClick}
                                disabled={createDemoAppointmentsLoading}
                            >
                                <Iconify icon="tabler:calendar-user" />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Divider orientation="vertical" flexItem sx={{ borderStyle: 'dashed' }} />
                </Stack>
            </Collapse>
        </Stack>
    );
}

export default ToolsAccordion;
